import { Loading, Typography } from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationJobPositionStatusChoices, useGetJobPositionAssignmentsQuery } from "@graphql/generated";
import JobCard from "@modules/JobSuggestion/components/JobCard";

const InactiveJobPositionsTabContent = () => {
  const status = AuthAccountOrganizationJobPositionStatusChoices.EXPIRED;
  const { data, loading } = useGetJobPositionAssignmentsQuery({
    variables: {
      jobPositionStatus: [status, AuthAccountOrganizationJobPositionStatusChoices.REJECTED],
    },
  });

  const jobPositions = data?.me?.jobPositionAssignments?.edges;

  if (loading) return <Loading />;

  return (
    <div className="flex flex-col gap-4 h-4/6 overflow-auto">
      {jobPositions?.length && jobPositions?.length > 0 ? (
        jobPositions?.map((job, index) => <JobCard key={index} jobPosition={job?.node} isDisabled />)
      ) : (
        <Typography variant="muted" className="text-center py-32">
          There is no job suggestion
        </Typography>
      )}
    </div>
  );
};

export default InactiveJobPositionsTabContent;
